import $http from '@/api';

export default {
  /**
   * Fetches board metadata
   * @param {Number} boardId - The board being edited.
   * @return {Promise<{}>}
   */
  getBoardMetadata(boardId) {
    return $http.get(`/api/board/${boardId}/editor`);
  },

  /**
   * Fetches board composition
   * @param {Number} boardId - The board being edited.
   * @return {Promise<{}>}
   */
  getBoardComposition(boardId) {
    return $http.get(`/api/board/${boardId}/composition`);
  },

  /**
   * Fetches the dayparting for the given board.
   * @param {Number} boardId - The board being edited.
   * @return {Promise<{}>}
   */
  async getBoardDayparting(boardId) {
    return $http.get(`/api/board/${boardId}/dayparting`);
  },
};
